import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { DirectionProvider } from '@pc/ds-react';
import { store, persistor } from './redux/store';
import PopupManager from './components/PopupManager';
import AppInitializer from './components/AppInitializer/AppInitializer';
import GlobalLoader from './components/GlobalLoader';
import JwtExpirationBanner from './components/JwtExpirationBanner';
import AppRoutes from './navigation/AppRoutes';
import './i18n/config';
import '@pc/ds-tokens/css';
import '@pc/ds-tokens/css/foundation';
import './assets/fonts/fonts.css';
import './assets/styles/shared.scss';
import './index.css';
//import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <DirectionProvider>
          <BrowserRouter>
            <JwtExpirationBanner />
            <AppInitializer />
            <AppRoutes />
            <PopupManager />
            <GlobalLoader />
          </BrowserRouter>
        </DirectionProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
